import Moment from 'moment';
import { getAllCountryList } from "../services/survey.service";
import { LANGUAGES, LHR_LANGUAGES, TPS_LANGUAGES, COC_LANGUAGES, CBAM_LANGUAGES, COO_LANGUAGES, SBTP_LANGUAGES } from '../utils/countries';
import { CRS_REQUEST_STATUS_OBJ, CRS_SURVEY_CODES, SCBM_CODE, SCBM_SUPPLIER_TYPE_ALLOWED, SCBM_USER_TYPE, DATE_FORMAT, SCBM_STATES_CAMPAIGN, CRS_INTERFACTORY_SURVEYS, DEFAULT_LANGUAGE_CODE, PROPS_TO_REMOVE, CODE_SURVEY_LANGUAGE, CODE_HELPDOC, ADMIN_SEC_TYPE, DISCLAIMER_MSG_CODE, DISCLAIMER_MSG_POSITION, CRS_ADMIN, SURVEYPART_SECTION_TYPES, DEFAULT_PART_SECTION_TRANSLATIONS } from '../utils/surveyLiterals';
import moment from "moment";
import { POPUP_QUESTIONS_TITLES, QUESTION_TYPES } from "./constants";


export const getAnswerLabel = (question, answers) => {
    let text = '-';
    //searching for answer in the array from main page
    let answer = answers.find(a => parseInt(a.questionId) === parseInt(question.id));
    if (question.type === 'OPEN' || question.type === 'OPEN_DATE' || question.type === 'DATE' || question.type === 'SECT' || question.type === 'TABLE_SEC1' || question.type === 'TABLE_SEC2' || question.type === 'OPTION_CTY') {
        text = answer ? answer.answer : '-';
    } else if (question.type === 'OPTION' || question.type === 'RADIO') {
        if (answer) {
            let selection = question.selections.find(a => a.value === answer.answer)
            //text = selection ? selection.text : '-';
            text = selection ? getTranslation(selection, 'text') : '-';
        }
    } else if (question.type === 'PERC_SALES' || question.type === 'PERC_STAT') {
        if (answer) {//Static array 
            text = answer.answer;
        }
    } else if (question.type === 'CHECK') {
        if (answer !== null && answer !== undefined) {//return an array of labels
            let arrayLabels = answer.answer ? answer.answer.slice(0, -1).split(',') : [];
            //return arrayLabels.map(opt => question.selections.find(a => a.value === opt).text);
            return arrayLabels.map(opt => getTranslation(question.selections.find(a => a.value === opt), 'text'));
        }
    }
    return text;
}

export const applyAnswerIfExists = (storedResponse, questionId) => {
    let selectedAnswer;
    if (storedResponse === undefined)
        return selectedAnswer;
    storedResponse.surveyAnswers.map(answer => {
        if (answer.questionId === questionId) {
            selectedAnswer = answer.answer
        }
        return answer
    })
    return selectedAnswer;
}

export const findAnswerIndex = (questionId, answers) => {
    return answers ? answers.findIndex(q => parseInt(questionId) === parseInt(q.questionId)) : -1;
}

export const findSelectionIndex = (value, selections) => {
    return selections ? selections.findIndex(s => value === s.value) : -1;
}

export const updateAnswerInArray = (questionId, answers, newValue) => {
    let newMap = [...answers];
    let questionIndex = newMap.findIndex(q => q.questionId === parseInt(questionId));
    if (questionIndex >= 0) {
        newMap[questionIndex] = { questionId: parseInt(questionId), answer: newValue };
    } else {
        newMap.push({ questionId: parseInt(questionId), answer: newValue });
    }
    return newMap;
}

//Check if the answer belongs to a checkbox question
export const isCheckBoxAnswer = (answer) => {
    return answer && answer.includes(',') ? true : false;
}

// Falls back to the legacy single value for questions created before multi-selection dependencies
export const getSelectionsDependson = (que) => {
    if (!que) return [];
    const deps = Array.isArray(que.idSelectionsDependson) && que.idSelectionsDependson.length > 0 ? que.idSelectionsDependson : [que.idSelectionDependson];
    return deps.filter((dep) => dep !== null && dep !== undefined).map(String);
}

// A child can be listed under several options, so keep any child that is also under a matching option
export const getChildrenToRemove = (children, isMatch) => {
    if (!Array.isArray(children)) return [];
    const kept = new Set(children.filter(isMatch).flatMap((ch) => ch.children || []).map(String));
    const removed = children.filter((ch) => !isMatch(ch)).flatMap((ch) => ch.children || []);
    return [...new Set(removed)].filter((id) => !kept.has(String(id)));
}

// Walks up the full dependency chain of a part question. True (disabled) if any link is not satisfied by the row
export const isPartQuestionDisabledByDependency = (rowData, question, questions) => {
    let current = question;
    const visitedQuestionIds = new Set();
    while (current.idQuestionDepends && current.idQuestionDepends !== 0) {
        if (visitedQuestionIds.has(current.id)) return true;
        visitedQuestionIds.add(current.id);

        const parentQue = questions.find((que) => que.id === current.idQuestionDepends);
        if (!parentQue) return true;
        const parentAns = rowData[`que_${parentQue.id}`];
        if (POPUP_QUESTIONS_TITLES.includes(parentQue.type)) {
            current = parentQue;
            continue;
        }
        if (parentQue.type === QUESTION_TYPES.CHECK) {
            const selectionDependsOn_Check = String(current.idSelectionDependson) === "0" ? "true" : "";
            const parentAns_Check = !parentAns || parentAns === "" ? "" : parentAns;
            if (parentAns_Check !== selectionDependsOn_Check) return true;
        } else if (parentQue.type === QUESTION_TYPES.MULTI_SEL) {
            const parentValues = (Array.isArray(parentAns) ? parentAns : String(parentAns).split(",")).map((value) => String(value).trim());
            if (!parentAns || !getSelectionsDependson(current).some((dep) => parentValues.includes(dep))) return true;
        } else {
            const deps = getSelectionsDependson(current).filter((dep) => dep !== "0");
            if (deps.length === 0) {
                if (!parentAns || parentAns === "") return true;
            } else {
                if (!parentAns || !deps.includes(String(parentAns))) return true;
            }
        }
        current = parentQue;
    }
    return false;
}

//Validate if the answer is for checkbox
export const containsCheckBoxAnswer = (value, answer) => {
    let array = answer ? answer.split(',') : [];
    return array.findIndex(ans => ans.toString() === value.toString()) >= 0 ? true : false;
}

//Update Answer for checkbox question, it has many values store in string '6,5,7,9'
export const getNewCheckValueAnswer = (questionId, answers, e) => {
    let tmpUsrAnswers = [...answers];
    let questionIndex = findAnswerIndex(questionId, tmpUsrAnswers);
    const checkAnswers = tmpUsrAnswers[questionIndex] ? tmpUsrAnswers[questionIndex].answer : '';
    let newValue = '';
    if (e.target.checked) {
        if (!containsCheckBoxAnswer(e.target.value, checkAnswers)) {
            newValue = checkAnswers + e.target.value + ',';
        }
    } else {
        let array = checkAnswers ? checkAnswers.split(',') : [];
        let filtered = array.filter(function (value, index, arr) {
            return value !== e.target.value;
        });

        if (filtered.length > 0 && filtered[0] !== '') {
            newValue = filtered.length > 0 ? filtered.join() : '';
        } else {
            newValue = null;
        }
    }
    return newValue;
}

export const removeQuestion = (questionId, answers) => {
    let tmp = [...answers];
    let idx = tmp.findIndex(q => q.questionId === parseInt(questionId));
    if (idx >= 0) {
        tmp[idx] = { ...tmp[idx], answer: '' };
    }
    return tmp;
}

//get the translation from firts parameter, the second argument is used in case the translation does not in the object,
//could be 'text' or 'description'
export const getTranslation = (object, defaultProperty) => {
    if (object && object.translations && object.translations.length > 0) {
        return object.translations[0].text;
    } else {
        return object ? object[defaultProperty] : '';
    }
}

export const getTranslationHelpText = (object, defaultProperty) => {
    if (object && object.translations && object.translations.length > 0) {
        if (object.translations[0].helpText){
            return object.translations[0].helpText;
        }else if(object.translations[0].text){
            return object.translations[0].text;
        }
    } else if (object && object.helpText) {
        return object.helpText
    }    
    return object[defaultProperty] ? object[defaultProperty] : '';    
}

export const getLDTranslation = (object, defaultProperty) => {
    if (object && object.translations && object.translations.length > 0) {
        return object.translations[0].longDescription;
    } else {
        return object ? object[defaultProperty] : '';
    }
}
export const getSelfServiceTranslation = (object, defaultProperty, currentLang, isLongDescription) => {
    if (object && object.translations && object.translations.length > 0) {
        const translation=object.translations.filter((t)=>t.locale===currentLang)
        if(translation && translation.length>0){
            return isLongDescription? translation[0].longDescription : translation[0].text;
        }else{
            return isLongDescription? object.longDescription : object.description;
        }
    } else {
        return object ? isLongDescription? object.longDescription : object.description : '';
    }
}

export const getTextTranslation = (object, defaultProperty, currentLang, isLongDescription) => {
    if (object && object.translations && object.translations.length > 0) {
        const translation=object.translations.filter((t)=>t.locale===currentLang)
        if(translation && translation.length>0){
            return isLongDescription? translation[0].longDescription : translation[0].text;
        }else{
            return isLongDescription? object.longDescription : object.text ? object.text : object.columnNames ? object.columnNames : '';
        }
    } else {
        return object ? isLongDescription? object.longDescription : object.text ? object.text : object.columnNames ? object.columnNames : '' : '';
    }
}

export const getHelpTextTranslation = (object, defaultProperty, currentLang) => {
    if (object && object.translations && object.translations.length > 0) {
        const translation=object.translations.filter((t)=>t.locale===currentLang)
        if(translation && translation.length>0){
            return translation[0].helpText? translation[0].helpText : translation[0].text;
        }else{
            return object.helpText;
        }
    } else {
        if(object?.translation){
            return object?.translation[0].helpText?object?.translation[0].helpText : object.text;
        }
        return object.text;
    }
}

export const getGroupTierArray = (tierForms, questions, hasDefault, code) => {
    const numQus = code === SCBM_CODE ? 6 : 7;
    let tierArray = [];
    let tierArrayTmp;
    if (tierForms && tierForms.length > 0) {
        tierArrayTmp = new Array(Math.round(tierForms.length / numQus));
        for (let i = 0; i < tierForms.length; i++) {
            if (tierArrayTmp[tierForms[i].tierIndex] === undefined) {
                tierArrayTmp[tierForms[i].tierIndex] = [];
            }
            tierArrayTmp[tierForms[i].tierIndex].push({ ...tierForms[i] });
        }

        //Fill attribuites missings
        tierArrayTmp.forEach(tier => {
            let questionsAns = [];
            for (let i = 0; i < numQus; i++) {
                questionsAns.push(questions[i]);
            }
            tier.forEach(obj => {
                if (obj !== undefined) {
                    questionsAns = questionsAns.filter(qu => qu.id !== obj.questionId);
                }
            });
            questionsAns.forEach(qu => {
                tier.push({
                    tierIndex: tier[0].tierIndex,
                    answer: '',
                    questionId: qu.id
                });
            });
        });

        for (let i = 0; i < tierArrayTmp.length; i++) {
            if (tierArrayTmp[i])
                tierArray.push(tierArrayTmp[i].sort((a, b) => (a.id > b.id) ? 1 : -1))
        }
    }
    if (hasDefault && tierArray.length <= 0) {
        const array = []
        for (let i = 0; i < numQus; i++) {
            array.push({
                tierIndex: 1,
                answer: '',
                questionId: questions[i].id
            })
        }

        tierArray.push(array);
    }
    return tierArray;
}

export const getDateFromTimeStamp = (timestamp) => {
    return Moment.utc(timestamp).format(DATE_FORMAT)
}

export const getPercentage = (hundred, value) => {
    return value > 0 ? Math.round(value * 100 / hundred) : 0;
}

export const isSupplierAllowed = (userType) => {
    return SCBM_SUPPLIER_TYPE_ALLOWED.includes(userType);
}

export const isInterfactory = (surveyCode) => {
    return CRS_INTERFACTORY_SURVEYS.includes(surveyCode);
}

export const isUserAnAdminOfSurvey = (userRoles, adminRole) => {
    return userRoles.find((uRole) => uRole === adminRole) ? true : false;
}

export const isUserACRSAdmin = (userRoles) => {
    return userRoles.find((uRole) => uRole === CRS_ADMIN) ? true : false;
}

export const supplierViewFinalSort = (assigments) => {
    let finalSort = []
    const requestCreated = []
    const rest = []
    assigments.forEach(assigment => {
        if (assigment.status.trim().toLowerCase() === CRS_REQUEST_STATUS_OBJ.REQUEST_CREATED.trim().toLocaleLowerCase()
            || assigment.status.trim().toLowerCase() === CRS_REQUEST_STATUS_OBJ.IN_PROCESS.trim().toLocaleLowerCase()) {
            requestCreated.push(assigment)
        }
        else rest.push(assigment)
    })
    requestCreated.sort(function (a, b) { return new Date(a.endDate) - new Date(b.endDate) })
    rest.sort(function (a, b) { return new Date(b.updatedts) - new Date(a.updatedts) })
    finalSort = [...requestCreated, ...rest]
    return finalSort
}


const orderCampaignBy = (array) => {
    if (!Array.isArray(array) || !array.length)
        return

    let sortBy = [{
        prop: 'status',
        direction: -1
    }, {
        prop: 'endDate',
        direction: 1
    }];

    return array.sort((a, b) => {
        let i = 0, result = 0;
        while (i < sortBy.length && result === 0) {
            result = sortBy[i].direction * (a[sortBy[i].prop].toString() < b[sortBy[i].prop].toString() ? -1 : (a[sortBy[i].prop].toString() > b[sortBy[i].prop].toString() ? 1 : 0));
            i++;
        }
        return result;
    })
}

const orderRequestsBy = (array) => {
    if (!Array.isArray(array) || !array.length)
        return;
    const statusOrder = ['Email Pending', 'Request Created', 'In Process', 'Complete', 'Incomplete']
    return array.sort((a, b) => {
        const dateA = new Date(a.endDate);
        const dateB = new Date(b.endDate)
        return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status) || dateA - dateB;
    })
}

export function orderBy(campaigns) {
    if (campaigns && campaigns.length > 0) {
        if (campaigns[0].type === 'assignment')
            return orderRequestsBy(campaigns)
        else
            return orderCampaignBy(campaigns)
    }
    return campaigns
}

export function dateConvert(timestamp) {
    const date = new Date(timestamp);
    const dateConverted =
        `${date.getDate()}-${date.toLocaleString('default', { month: 'short' })}-${date.getFullYear()} ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
    return dateConverted;
}

export const isTokenExpired = (expiresAt) => {
    if (!expiresAt) { return true };
    // divide by 1000 to remove milliseconds and just get the time in seconds
    const secondsToExpire = expiresAt - new Date().getTime() / 1000;

    if (secondsToExpire < 0) {
        return true;
    }

    return false;
};

export const getSurveyLanguages = (surveyCode) => {
    switch (surveyCode) {
        case CRS_SURVEY_CODES.TPS:
            return TPS_LANGUAGES
        case CRS_SURVEY_CODES.LHR:
            return LHR_LANGUAGES
        case CRS_SURVEY_CODES.COC:
            return COC_LANGUAGES
        case CRS_SURVEY_CODES.COO:
            return COO_LANGUAGES
        case CRS_SURVEY_CODES.CBAM:
            return CBAM_LANGUAGES
        case CRS_SURVEY_CODES.SBTP:
            return SBTP_LANGUAGES
        default:
            return LANGUAGES
    }
};

export const isValidRequestNumber = (requestNumber) => {
    return requestNumber && !isNaN(requestNumber) && Number.isInteger(parseFloat(requestNumber));//Size in DB
}

export const validationRules = (respCampaign, userInfo) => {
    let error;
    if (respCampaign) {
        let campaign = respCampaign;
        if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
            //it is normal user, we have to validate that the current user has the supplier
            if (!userInfo.suppliers || userInfo.suppliers.length <= 0 || !userInfo.suppliers.includes(campaign.assignments[0].supplierNumber)) {
                error = 'No suppliers assigned';
            }//else everything is OK
        }//else Read only for the deere employee
    } else {//The assignment does not exist
        error = 'No campaing found';
    }
    return error;
}

export const getSubtierUniquesAndDuplicates = (completedSTList) => {
    let duplicatedSTList = [];
    let uniqueSTList = [];

    console.time('UAD Timer');
    let auxCompletedSubTierList = Array.isArray(completedSTList) && completedSTList.length > 0 ? [...completedSTList] : [];
    for (let i = 0; i < auxCompletedSubTierList.length; i++) {
        const completedST = auxCompletedSubTierList[i]
        const tmpSupplierSubtier = auxCompletedSubTierList.find((uniqueSubtier) => (uniqueSubtier.subtierSupplierName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') === completedST.subtierSupplierName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') && uniqueSubtier.id !== completedST.id));
        if (tmpSupplierSubtier) {
            duplicatedSTList.push(completedST) //Not Unique
        } else {
            const indexSecondSpace = completedST.subtierSupplierName.indexOf(" ", completedST.subtierSupplierName.indexOf(" ", 0));
            const shortName = completedST.subtierSupplierName.slice(0, indexSecondSpace).toLowerCase().replace(/[^a-zA-Z0-9]/g, '');

            //Validating shor name without punctuation marks
            const tmpSubtier = auxCompletedSubTierList.find((uniqueSubtier) => (uniqueSubtier.subtierSupplierName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(shortName) && uniqueSubtier.id !== completedST.id));
            if (tmpSubtier) {
                duplicatedSTList.push(completedST) //Not Unique
            } else {
                uniqueSTList.push(completedST) //Is unique no matches with the whole name neither the short name(We are considering the two first words)
            }
        }

    }
    console.timeEnd('UAD Timer');
    const response = { duplicatedSTList, uniqueSTList }
    return response;


}

export function getLikeNameRecords(incompletedSubtierList, duplicatedSubtierList) {
    console.time('getLikeNameRecords Timer');
    const regChineseExp = /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/g;

    let auxSubTierList =
        duplicatedSubtierList.filter(duplicate => {
            let found = regChineseExp.test(duplicate.subtierSupplierName)
            if(!found){
                return duplicate
            }
        })


    const map = new Map();

    auxSubTierList.sort((a, b) => {
        const fa = a.subtierSupplierName.toLowerCase();
        const fb = b.subtierSupplierName.toLowerCase();
        if (fa < fb) return -1;
        if (fa > fb) return 1;
        return 0;
    })

    while (auxSubTierList.length > 0) {
        const subTierTopElement = auxSubTierList.shift()
        let shortName = subTierTopElement.subtierSupplierName.replaceAll(/[^\w\s]/gi, '').split(' ').slice(0, 2).join(' ');
        if (shortName && shortName.length > 0 && shortName.split(' ').length === 2) {
            const words = shortName.split(' ');
            const fistWord = words[0] ? words[0].trim().toLowerCase() : ''
            const secondWord = words[1] ? words[1].trim().toLowerCase() : ''
            if (fistWord.length === 1 && secondWord.length === 1) {
                shortName = subTierTopElement.subtierSupplierName.replaceAll(/[^\w\s]/gi, '').split(' ').slice(0, 3).join(' ');
            }
        }
        const regexp = new RegExp(shortName, 'i');
        const coincidences = auxSubTierList.filter(element => regexp.test(element.subtierSupplierName.replaceAll(/[^\w\s]/gi, '').toLowerCase()))
        if (Array.isArray(coincidences) && coincidences.length > 0) {
            auxSubTierList = auxSubTierList.filter(el => !coincidences.includes(el))
            coincidences.unshift(subTierTopElement)
            map.set(subTierTopElement.id, coincidences)
        }
    }

    console.timeEnd('getLikeNameRecords Timer');
    return map;
}

export async function getCountryList(token){
    return getAllCountryList(token)
        .then((res) => {
            if (res.length !== 0) {
            let temp = [];
            res.forEach((item) => temp.push({ value: item.iso2CountryCode, label: item.name}));
            return temp;
        }})
        .catch((err) => console.log(err));
}

export function formatStrDate(date) {
    if(moment(date).isValid()){
        return moment(date).format('DD-MMM-YYYY')
    }
}

export function getRequestStatusWhenCampaignClosed(reqStatus, campaignStatus) {
    if(reqStatus){
        if(campaignStatus && campaignStatus === SCBM_STATES_CAMPAIGN.CLOSED && reqStatus === CRS_REQUEST_STATUS_OBJ.INCOMPLETE){
            return `${reqStatus} (${campaignStatus})`
        }
        return reqStatus;
    }
    return "";
}

export const getExcelColumn = (index) => {
    let columnName = '';
    while (index > 0) {
        let remainder = (index - 1) % 26;
        columnName = String.fromCharCode(65 + remainder) + columnName;
        index = Math.floor((index - 1) / 26);
    }
    return columnName;
};

/****************************************Self Service Utils Start****************************************/
export const generateSurveyCode = (surveyName, existingSurveyCodes) => {
    let code = "";
    const words = surveyName.split(" ");
    if (words.length === 1) {
      code = words[0]
        .replace(/[^a-zA-Z]/g, "")
        .substring(0, 3)
        .toUpperCase();
    } else {
      code = words.reduce((acronym, word) => {
        const firstLetter = word.match(/[a-zA-Z]/);
        if (firstLetter) {
          acronym += firstLetter[0].toUpperCase();
        }
        return acronym;
      }, "");
    }
    if (existingSurveyCodes.includes(code)) {
      let i = 1;
      while (existingSurveyCodes.includes(code + i)) {
        i++;
      }
      code = code + i;
    }
    return code;
  };

  export const sortByLanguageList = (data, languageList) => {
    if (data && languageList) {
      const sortedList = languageList.sort((a, b) => (a.id > b.id ? 1 : -1));
      if (Array.isArray(data)) {
        const returnData = [];
        sortedList.forEach((lang) => {
          const index = data.findIndex((d) => d.language ? lang.language === d.language : lang.language === d.text);
          if (index > -1) returnData.push(data[index]);
        });
        return returnData;
      } else {
        let returnData = "";
        sortedList.forEach((lang) => {
          const index = data.split(", ").findIndex((d) => lang.language === d);
          if (index > -1) returnData === "" ? (returnData = lang.language) : (returnData += `, ${lang.language}`);
        });
        return returnData;
      }
    } else return data;
  };

  export const removeUnwantedProperties = (obj) =>  {
    if (obj && typeof obj === "object") {
      for (const key in obj) {
        if (PROPS_TO_REMOVE.includes(key)) {
          delete obj[key];
        } else {
          if (Array.isArray(obj[key])) {
            obj[key].forEach((item) => removeUnwantedProperties(item));
          } else {
            removeUnwantedProperties(obj[key]);
          }
        }
      }
    }
  }

  //Predefined translations apply only while a default section keeps its default title; renamed sections keep the admin's translations or get empty ones
  export const buildDefaultSectionTranslations = (section, selectedLanguages) =>
    selectedLanguages
      .filter((sl) => sl.languageCd !== DEFAULT_LANGUAGE_CODE)
      .map((sl) => {
        const existing = (section.translations || []).find((t) => t.locale === sl.languageCd);
        const predefinedText = DEFAULT_PART_SECTION_TRANSLATIONS[section.description]?.[sl.languageCd];
        return { locale: sl.languageCd, language: sl.text, text: predefinedText ?? existing?.text ?? "", longDescription: existing?.longDescription ?? "" };
      });

  export const prepareSurveyData = (surveyData, literalData, notificationData) => {
    surveyData.language = literalData.filter((ld) => ld.code.toLowerCase() === `${surveyData.code.toLowerCase()}_${CODE_SURVEY_LANGUAGE}`);
    surveyData.helpDocs = literalData
      .filter((ld) => ld.code === `${surveyData.code.toLowerCase()}_${CODE_HELPDOC}`)
      .map((ld) => {
        return { ...ld, docName: ld.text, isNewUpload: false };
      });
    let questionList = [];
    surveyData.sections = surveyData.sections.filter((sec) => sec.type !== ADMIN_SEC_TYPE);
    surveyData.sections.forEach((sec) => (questionList = questionList.concat([...sec.questions])));
    surveyData.sections.forEach((sec) => {
       if(sec.type === SURVEYPART_SECTION_TYPES.RESPONSES || sec.type === SURVEYPART_SECTION_TYPES.SUPPLIER) {
        sec.isDefault = true;
       }
    });
    surveyData.sections.forEach((sec) => {
      sec.questions.forEach((que) => {
        if (que.idQuestionDepends && que.idQuestionDepends !== "" && que.idQuestionDepends !== 0) {
          const index = questionList.findIndex((ql) => ql.id === que.idQuestionDepends);
          if (index > -1) que.codeQuestionDepends = questionList[index].code;
        }
        if ((!Array.isArray(que.idSelectionsDependson) || que.idSelectionsDependson.length === 0) && que.idSelectionDependson) {
          que.idSelectionsDependson = [que.idSelectionDependson];
        }
      });
    });
    surveyData.agreementData = literalData.filter((ld) => ld.code === DISCLAIMER_MSG_CODE);
    const agreementPosition = literalData.find((ld) => ld.code === DISCLAIMER_MSG_POSITION);
    surveyData.agreementPosition = agreementPosition && agreementPosition.text ? agreementPosition.text : "";
    surveyData.surveyNotification = notificationData && Array.isArray(notificationData) && notificationData.length > 0 ? notificationData[0].template : "";
    return surveyData;
  };

  /****************************************Self Service Utils End****************************************/